<template>
  <div>
    <div class="heard">
      <div style="cursor: pointer;  overflow: hidden;" @click="closeTip">
        <i style="font-size: 28px;display: flex;float: right" class="el-icon-close"></i>
      </div>
      <el-scrollbar style="height: 100%;">
        <div style="width: 80%;margin: 0 auto;">
          <br>
          <div style="text-align: center;font-size: 20px">
            当前用户: {{ this.data_json.name }}
          </div>
          <br>
          <el-row>
            <span style="margin-right: 20px;text-align: left;font-size: 20px">
              岗位:
            </span>
            <el-cascader
              style="width: 55%;"
              placeholder="请选择部门及岗位"
              @change="updatepost"
              v-model="selec"
              :options="optionsList"
            ></el-cascader>
            <el-button v-show="isUpdate" @click="saveuser" type="primary">保存</el-button>
          </el-row>
          <br>
          <el-row>
            <el-button type="danger" @click="resetRecord">重置用户学习记录</el-button>
            <el-button type="danger" @click="resetPassword">重置用户密码</el-button>
            <el-button type="danger" @click="setAnUser" v-show="data_json.branch_id !== 3">设置为岸基用户</el-button>
          </el-row>

        </div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import * as req from '@/utils/request'

export default {
  props: ['data_json'],
  name: 'topic_dialog',
  data () {
    return {
      optionsList: [],
      stationList: [],
      isUpdate: false,
      selec: [1, 1],
      isClear: true,
      oldStation_id: null
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.oldStation_id = this.data_json.station_id
      // debugger
      let array = this.global.optionsList
      for (let i in array) {
        if (array[i].label === '岸基部') {
          continue
        }
        this.optionsList.push(array[i])
      }
      this.saveuser2()
    })
  },
  created () {
  },
  methods: {
    // 设置为岸基用户
    setAnUser (row) {
      let userInfo = this.data_json
      if (userInfo.branch_id === 3) {
        this.$message.warning('当前已是岸基人员')
        return
      }
      this.resetRecord()

      let msg = {}
      this.oldStation_id = this.data_json.station_id
      msg.id = this.data_json.id
      msg.data = [3, 12] // 岸基部  机务主管
      let sendData = {}
      sendData.data = msg
      sendData.fn = this.setAnUserFn
      sendData.vm = this
      req.Post('user/updatepost', sendData)
    },
    setAnUserFn (data) {
      if (data.err_code !== 0) {
        alert(data.err_msg)
        return
      }
      this.$message.success('修改成功')
      this.$parent.$parent.updateDialog = false
    },
    saveuser2 () {
      let obj = []
      obj.push(this.data_json.branch_id)
      obj.push(this.data_json.station_id)
      this.selec = obj
    },
    saveuser () {
      // 修改岗位前必须重置学习记录
      this.resetRecord()
      let msg = {}
      this.oldStation_id = this.data_json.station_id
      msg.id = this.data_json.id
      msg.data = this.selec
      let sendData = {}
      sendData.data = msg
      sendData.fn = this.saveuserFn
      sendData.vm = this
      req.Post('user/updatepost', sendData)
    },
    // 记录日志
    addLog (data) {
      let msg = {}
      msg.name = this.global.user_info.name
      if (!msg.name) {
        return
      }
      msg.logs = data
      let sendData = {}
      sendData.data = msg
      sendData.vm = this
      req.Post('user/addLog', sendData)
    },
    saveuserFn (data) {
      if (data.err_code !== 0) {
        alert(data.err_msg)
        return
      }
      this.oldStation_id = null
      this.$parent.$parent.getData()
      this.isUpdate = false
      this.addLog('修改用户 ' + this.data_json.name + '岗位')
    },
    updatepost (s) {
      this.isUpdate = true
      this.selec[0] = s[0]
      this.selec[1] = s[1]
    },
    resetPassword () {
      // let name = this.global.user_info.name
      // if (!name) {
      //   this.$message.error('当前未登录')
      //   return
      // }
      let msg = {id: this.data_json.id}
      let str = this.data_json.id_number
      let six = str.substring(str.length - 6, str.length)
      msg.data = this.$md5(six)
      let sendData = {}
      sendData.data = msg
      sendData.fn = this.resetPasswordFn
      sendData.vm = this
      req.Post('user/resetPassword', sendData)
    },
    resetPasswordFn (data) {
      if (data == null) {
        this.$message.warning('重置密码失败！')
        return
      }
      this.addLog('重置了用户 ' + this.data_json.name + ' 的密码')
      this.$message.success('重置密码成功！')
    },
    resetRecord () {
      let msg = {id: this.data_json.id}
      // if (this.global.video.length === 0) {
      //   this.$message.warning('当前学员无视频记录')
      // }
      if (((this.data_json.study_record == null ||
        this.data_json.study_record === '' ||
        this.data_json.study_record === '{}')) && this.data_json.played.length === 0) {
        // this.$message.warning('当前学员无学习记录')
      }
      if (!this.isClear) { // 如果重复点击
        this.$message.warning('当前学员无学习记录')
        return
      }
      let sort = {
        station_id: this.data_json.station_id,
        branch_id: this.data_json.branch_id,
        serve_ship: this.data_json.serve_ship
      }
      if (this.oldStation_id !== null) {
        sort.station_id = this.oldStation_id
      }
      msg.study_record = this.data_json.study_record
      msg.played = this.data_json.played
      msg.sort = JSON.stringify(sort)
      let sendData = {}
      sendData.data = msg
      sendData.fn = this.resetRecordFn
      sendData.vm = this
      req.Post('user/resetRecord', sendData)
    },
    resetRecordFn (data) {
      if (data == null) {
        return
      }
      if (data.err_code !== 0) {
        // this.$message.error('当前无学习记录')
        return
      }
      this.$message.success('清空完成')
      // 当前用户只能清空一次学习记录
      this.isClear = false
      this.data_json.study_record = '{}'
      this.addLog('清空了用户 ' + this.data_json.name + '学习记录')
      this.$parent.$parent.getData()
    },
    closeTip () {
      this.$parent.$parent.updateDialog = false
      this.$parent.$parent.model = 0
      this.$parent.$parent.updateData = {}
      this.isUpdate = false
      this.isClear = true
    }
  }
}
</script>

<style scoped>
.heard {
  font-family: 'Muli', sans-serif;
  width: 950px;
  /*border: 5px solid #5b98d6;*/
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 8);
  position: fixed;
  min-height: 25vh;
  max-height: 25vh;
  padding: 15px;
  top: 110px;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0 auto;
  border-width: 3px 0px 0 0;
  border-style: solid;
  border-color: #66b1ff;
  overflow: hidden;
}

/deep/ -webkit-scrollbar {
  width: 0px;
  height: 0px;
}

/deep/ -webkit-scrollbar-thumb {
  background-color: rgba(238, 236, 236, 0.26);
  border-radius: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/update_dialog.vue